var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var RootPane_1 = require("./components/RootPane");
var store_1 = require("./store");
exports.default = (function (_a) {
    var namespace = _a.namespace, contentTypes = _a.contentTypes;
    var actions = store_1.actionsFactory(namespace);
    var mapStateToProps = function (_a) {
        var panes = _a.panes;
        var entry = panes[namespace];
        return {
            panes: entry === undefined ? [] : entry.panes,
            contentTypes: contentTypes,
        };
    };
    var mapDispatchToProps = function (dispatch) { return ({
        init: function () {
            dispatch(actions.initPanesNamespace());
        },
        setCurrentPane: function (paneId) {
            dispatch(actions.setCurrentPane(paneId));
        },
        addContentToCurrentPane: function (content) {
            dispatch(actions.addContentToCurrentPane(content));
        },
        setPaneCurrentContent: function (paneId, contentId) {
            dispatch(actions.setPaneCurrentContent(paneId, contentId));
        },
        removePaneContent: function (paneId, contentId) {
            dispatch(actions.removePaneContent(paneId, contentId));
        },
        removeContentFromAllPanes: function (contentId) {
            dispatch(actions.removeContentFromAllPanes(contentId));
        },
        splitPane: function (paneId, axis) {
            dispatch(actions.splitPane(paneId, axis));
        },
    }); };
    var NameSpacedRootPane = /** @class */ (function (_super) {
        __extends(NameSpacedRootPane, _super);
        function NameSpacedRootPane() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return NameSpacedRootPane;
    }(RootPane_1.default));
    return react_redux_1.connect(mapStateToProps, mapDispatchToProps)(NameSpacedRootPane);
});
